export function ensureLinkWithProtocol(url: string): string {
  return url.match(/^http?.*/) ? url : `http://${url}`;
}
